import { NestedDropdown } from "dyl-components";
import React from "react";
import { useSelector } from "react-redux";
import { StringUtils } from "utils";

const OrderStatusField = ({ name, value, onChange }) => {
    const [parent_value, child_value] = (value || "").split("/");
    const isUneditable = parent_value === "completed";
    const order = useSelector((state) => state.order.order);
    const statusOptions = (() => {
        if (value === "account_canceled") {
            return ["account_canceled"];
        }
        if (isUneditable) {
            return ["completed", "deleted"];
        }
        if (order?.order_status === "open") {
            return ["open", "deleted"];
        }   
        return ["draft", "open", "deleted"];
    })();
    return (
        <NestedDropdown
            parent_value={parent_value}
            child_value={child_value}
            label="Status"
            allowedToSelectParentOnly
            allowedToSelectParent
            onChange={(e, { parent_value, child_value }) => {
                onChange(e, {
                    name,
                    value: child_value
                        ? `${parent_value}/${child_value}`
                        : parent_value,
                });
            }}
            display_parent
            selection
            nested_options={statusOptions.map((status) => ({
                key: status,
                value: status,
                text: (status || "").split("_").map((word) => StringUtils.capitalize(word)).join(" "),
                options: [],
            }))}
            selectOnBlur={false}
            clearable={false}
            placeholder="Select status"
        />
    );
};

export default OrderStatusField;
